import createParseMiddleware from './createParseMiddleware';
import { parseKioskResponse } from 'utils/apiParser/kioskParser';
import { Kiosk } from 'types/kioskTypes';

export const parseFetchKioskMiddleware = createParseMiddleware<Kiosk>(parseKioskResponse, 'kiosks/fetchKiosks');
export const parseDescribeKioskMiddleware = createParseMiddleware<Kiosk>(parseKioskResponse, 'kiosks/describeKiosk');
